import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { generatorView, tooltips } from '../../../constants/profileSettings';
import Profile from "../../../models/Profile";
import { Log, logAction, logType } from './../../../utils/api';
import translations from './translations';


interface IProps extends InjectedIntlProps{
  currentView: string
  generatorCount: number
  searchQuery: string
  title: string
  dispatchFilterEvent: (query: string) => void
  onViewChange: any,
  profile: Profile;
  uploadClicked: () => void
}

class TopNav extends React.Component<IProps, {}> {


  constructor(props: IProps) {
    super(props);
  }

  public getButtonClass = (tooltip: boolean, active: boolean, orientation: string) => {
    let buttonClass: string = "";

    if (active) {
      if (tooltip) {
        buttonClass = "button is-info tooltip"
      } else {
        buttonClass = "button is-info"
      }
    } else {
      if (tooltip) {
        buttonClass = "button tooltip"
      } else {
        buttonClass = "button"
      }
    }
    buttonClass = buttonClass + " is-tooltip-" + orientation;
    return buttonClass;
  }

private clickedUpload = () => {
  this.props.uploadClicked();
  Log(logType.action, logAction.clickHandler, "TopNav" , "Pressed the Upload button!");
}

  public render (){
    return (
      <>
        <h1 className="title" >{this.props.title}</h1>
        <nav className="level" >
            <div className="level-left">
                <div className="level-item">
                    <p className="subtitle is-5">
                        <strong>{this.props.generatorCount}</strong> {(this.props.generatorCount === 1) ? this.props.intl.formatMessage(translations.generator) : this.props.intl.formatMessage(translations.generators) }
                    </p>
                </div>
                <p className="level-item">
                    <Link to="/edit/new" onClick={() => Log(logType.action, logAction.clickHandler, "TopNav" , "Pressed New Generator button!")} data-tooltip={this.props.intl.formatMessage(translations.openNewGenerator)} className={this.props.profile.showTooltips ===  tooltips.on ? "button is-success tooltip" : "button is-success"} ><FormattedMessage {...translations.new} /></Link> {/*tslint:disable-line */}
                </p>
                <p className="level-item">
                  <a onClick={this.clickedUpload} data-tooltip={this.props.intl.formatMessage(translations.uploadTooltip)} className={this.props.profile.showTooltips ===  tooltips.on ? "button tooltip" : "button"} >
                    <span className="icon is-small is-right">
                      <i className="fas fa-upload"/>
                    </span>
                  </a>
                </p>
                <div className="level-item is-hidden-tablet-only">
                    <div className="field has-addons">
                        <p className={this.props.profile.showTooltips ===  tooltips.on ? "control has-icons-right tooltip" : "control has-icons-right"}  data-tooltip={this.props.intl.formatMessage(translations.pressEscToEmpty)}>
                            <input
                              type="text"
                              className="input"
                              placeholder={this.props.intl.formatMessage(translations.typeToSearch)}
                              onChange={this.onFilterChange}
                              onKeyDown={this.handleKeyDownSearchBar}
                              value={this.props.searchQuery}
                            />
                            <span className="icon is-small is-right">
                              <i className="fas fa-search"/>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="level-right">
              <div className="level-item">
              {this.props.intl.formatMessage(translations.display)}:
              </div>
              <div className="level-item">
                <p className="buttons">
                  <button className={this.props.currentView === generatorView.cardView ?  (this.props.profile.showTooltips ===  tooltips.on ? "button is-info tooltip is-tooltip-left" : 'button is-info') : (this.props.profile.showTooltips ===  tooltips.on ? "button tooltip is-tooltip-left" : 'button')} onClick={this.buttonCardView} data-tooltip={this.props.intl.formatMessage(translations.cardView)}>
                    <span className="icon is-small">
                      <i className="fa fa-table"/>
                    </span>
                  </button>
                  <button  className={this.props.currentView === generatorView.listView ? (this.props.profile.showTooltips ===  tooltips.on ? "button is-info tooltip is-tooltip-left" : 'button is-info') : (this.props.profile.showTooltips ===  tooltips.on ? "button tooltip is-tooltip-left" : 'button')} onClick={this.buttonListView} data-tooltip={this.props.intl.formatMessage(translations.listView)}>
                    <span className="icon is-small">
                      <i className="fa fa-list"/>
                    </span>
                  </button>
                </p>
              </div>
            </div>
          </nav>
      </>
    )
  }

  // Class Methods

  private buttonCardView = () => {
    this.props.onViewChange(generatorView.cardView);
    Log(logType.action, logAction.clickHandler, "TopNav" , "Pressed the Card View button!");
  }
  private buttonListView = () => {
    this.props.onViewChange(generatorView.listView);
    Log(logType.action, logAction.clickHandler, "TopNav" , "Pressed the List View button!");
  }
  private onFilterChange = (e: React.FormEvent<HTMLInputElement>): void => {
    this.props.dispatchFilterEvent(e.currentTarget.value)
  }

  private handleKeyDownSearchBar = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.keyCode === 27) {
      this.props.dispatchFilterEvent('')
    }
  }

};

export default injectIntl(TopNav);



// WEBPACK FOOTER //
// ./src/Containers/generators/GeneratorList/TopNav.tsx